module.exports = __webpack_public_path__ + "img/84000.4f0d3f39.jpg";